import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from "primereact/inputtext";
import { Controller, useForm } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import Select from "react-select";
import { Checkbox } from "primereact/checkbox";
import { InputTextarea } from 'primereact/inputtextarea';
import { Editor } from 'primereact/editor';





const FormBuilder = ({ open, data, handleCloseBuilder }) => {
    const [visible, setVisible] = useState(open);
    const [isRequired, setIsRequired] = useState(true);
    const [fieldType, setFieldType] = useState('');


    const renderHeader = () => {
        return (
            <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
                <button className='ql-link' aria-label='Link'></button>
            </span>
        );
    };

    const header = renderHeader();

    const handleClose = (data) => {
        handleCloseBuilder({});
        setVisible(false);
    }

    const defaultValues = {
        name: "",
        label: "",
        type: "",
        isRequired: true,
        message: "",
        options: ""
    };
    const {
        control,
        formState: { errors },
        handleSubmit
    } = useForm({ defaultValues });

    const onSubmit = (data) => {
        if (data.type === 'select' && data.options) {
            let opt = data.options.split(';')
            data.options = opt.map(i => { return { "value": i, "label": i } })
        }
        setVisible(false);
        handleCloseBuilder(data);

    };

    const fieldTypeOptions = [
        { value: '', label: '' },
        { value: 'text', label: 'Text' },
        { value: 'select', label: 'Select' },
        { value: 'check', label: 'Check' },
        { value: 'number', label: 'Number' },
        { value: 'email', label: 'Email' }
    ];

    const getFormErrorMessage = (name) => {
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
    };
    return (
        <>
            <Dialog header="Form Builder" visible={visible} style={{ width: '50vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => handleClose()}>
                <div className="card">
                    <form onSubmit={handleSubmit(onSubmit)} >
                        <div className="field">
                            <Controller
                                name="type"
                                control={control}
                                rules={{ required: 'Field type is required' }}
                                render={({ field, fieldState, ref, value }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                                        <span className="p-float-label">
                                            <Select
                                                inputRef={ref}
                                                classNamePrefix="addl-class"
                                                options={fieldTypeOptions}
                                                value={fieldTypeOptions.find(c => c.value === value)}
                                                className={classNames({ 'p-invalid': fieldState.error })}
                                                onChange={(val) => { field.onChange(val.value); setFieldType(val.value) }}
                                            />
                                        </span>
                                        {getFormErrorMessage(field.name)}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field">
                            <Controller
                                name="name"
                                control={control}
                                rules={{ required: 'Name  is required.' }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                                        <span className="p-float-label">
                                            <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                            <label htmlFor={field.name}>Field Name </label>
                                        </span>
                                        {getFormErrorMessage(field.name)}
                                    </>
                                )}
                            />
                        </div>
                        {fieldType === 'check' &&
                            <div className="field">
                                <Controller
                                    name="label"
                                    control={control}
                                    rules={{ required: 'Label  is required.' }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <Editor id={field.name} name="blog" value={field.value} headerTemplate={header} onTextChange={(e) => field.onChange(e.htmlValue)} style={{ height: '320px' }} />
                                            {getFormErrorMessage(field.name)}
                                        </>
                                    )}
                                />
                            </div>
                        }
                        {fieldType !== 'check' &&
                            <div className="field">
                                <Controller
                                    name="label"
                                    control={control}
                                    rules={{ required: 'Label  is required.' }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                                            <span className="p-float-label">
                                                <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                                <label htmlFor={field.name}>Field Label </label>
                                            </span>
                                            {getFormErrorMessage(field.name)}
                                        </>
                                    )}
                                />
                            </div>
                        }

                        <div className="field">
                            <Controller
                                name="isRequired"
                                control={control}
                                // rules={{ required: 'Required field is required.' }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.checked })}></label>
                                        Required? &nbsp;<Checkbox inputId={field.name} checked={field.value} inputRef={field.ref} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => { field.onChange(e.checked); setIsRequired(e.checked) }} />
                                        &nbsp;&nbsp; {getFormErrorMessage(field.name)}
                                    </>
                                )}
                            />
                        </div>
                        {isRequired &&
                            <div className="field">
                                <Controller
                                    name="message"
                                    control={control}
                                    rules={{ required: 'Required message  is required.' }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                                            <span className="p-float-label">
                                                <InputText id={field.name} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                                <label htmlFor={field.name}>Required message </label>
                                            </span>
                                            {getFormErrorMessage(field.name)}
                                        </>
                                    )}
                                />
                            </div>
                        }
                        {fieldType === 'select' &&
                            <div className="field">
                                <Controller
                                    name="options"
                                    control={control}
                                    rules={{ required: 'Options are required' }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>
                                            <span className="p-float-label">
                                                <InputTextarea id={field.name} rows={4} cols={30} value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                                                <label htmlFor={field.name}>Options(;Semicolon seperated )</label>
                                            </span>
                                            {getFormErrorMessage(field.name)}
                                        </>
                                    )}
                                />
                            </div>}

                        <div className="flex justify-content-end">
                            <Button label="Submit " type="submit" outlined />
                        </div>
                    </form>
                </div>
            </Dialog>

        </>
    )
}

export default FormBuilder